export default __webpack_public_path__ + "static/media/bg.cf8cb345.jpg";